// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-styles_btn__z2OS0 {
    align-items: center;
    grid-gap: 10px;
    /*padding: 0 14px;*/
    padding: 0 24px;
    /*width: 100%;*/
    color: #fff;
    border: 0.5px solid var(--primary-color);
    background: var(--primary-color);
    font-size: 14px;
    height: 40px;
    min-height: 40px;
    /*line-height: 40px;*/
    transition:
        background-color 0.4s,
        border-color 0.4s,
        color 0.4s;
    display: inline-flex;
    text-align: center;
    justify-content: center;

    /*--icon-color-custom: var(--primary-color);*/
}

.button-styles_btn__z2OS0:not(.button-styles_hasMinWidth__tXxri) {
    min-width: 75px;
}

.button-styles_btn__z2OS0.button-styles_hasMinWidth__tXxri {
    min-width: 140px;
}

.button-styles_btn__z2OS0.button-styles_grey__w-EJ5 {
    --primary-color: #7b848e;
}

.button-styles_btn__z2OS0 svg {
    width: 20px;
    height: 20px;
    max-width: 100%;
    max-height: 100%;
}

.button-styles_btn__z2OS0:not(.button-styles_secondary__q\\+4SW) {
    border-radius: 10px;
}

.button-styles_withIcon__NpFyl {
    padding: 0 14px;
    /*min-width: 120px;*/
}

.button-styles_btn__z2OS0:not(:disabled):hover {
    border-color: var(--primary-color-active);
    background: var(--primary-color-active);
    color: #fff;

    --icon-color-custom: #fff;
}

.button-styles_outline__l2CFi {
    background: transparent;
    color: var(--primary-color);
    --icon-color-custom: var(--primary-color);
    /*border-radius: 2px;*/
    /*font-weight: 300;*/
}

.button-styles_outline__l2CFi:not(:disabled):hover {
    background: #1650b4;
    border-color: #1650b4;
    color: #fff;
}

/*.btn:disabled:not(.disabledLight) {*/
/*    color: #7b848e;*/
/*    border-color: var(--light-grey);*/
/*    background-color: var(--light-grey);*/

/*    --icon-color-custom: #7b848e;*/
/*}*/

/*.btn:disabled.disabledLight {*/
/*    border-color: var(--light-grey);*/
/*    color: var(--light-grey);*/
/*    --icon-color-custom: var(--light-grey);*/
/*    opacity: 0.8;*/
/*}*/

/*.btn:disabled.outline {*/
/*    background: #f0f3f7;*/
/*    border-color: #1650b4;*/
/*    color: #1650b4;*/
/*    --icon-color-custom: #1650b4;*/
/*    opacity: 1;*/
/*}*/

.button-styles_btn__z2OS0 span {
    margin-top: auto;
    margin-bottom: auto;
    display: inline-flex;
}

.button-styles_fullWidth__WtK-M {
    width: 100%;
}

.button-styles_minWidth__NDeXg {
    min-width: 300px;
    justify-content: flex-start;
}

.button-styles_close__fjkOj {
    background: transparent;
    border: 0;
    position: absolute;
    z-index: 4;
    top: 14px;
    right: 14px;
    padding: 2px;
}

.button-styles_secondary__q\\+4SW {
    background-color: #f0f3f7;
    color: #1650b4;
    border-color: #1650b4;
    border-radius: 5px;
    min-width: 110px;

    /*background: #fbfbfb;*/
    /*border-color: #0c3b8d;*/
    /*color: var(--primary-color);*/
}

.button-styles_secondary__q\\+4SW.button-styles_outline__l2CFi {
    background-color: #ffffff;
}

.button-styles_btn__z2OS0:disabled {
    cursor: default;
    border-color: var(--light-grey);
}

.button-styles_btn__z2OS0:not(.button-styles_secondary__q\\+4SW):disabled {
    background-color: var(--light-grey);
    color: #fff;
}

.button-styles_btn__z2OS0.button-styles_secondary__q\\+4SW:disabled {
    color: var(--light-grey);
    --icon-color-custom: var(--light-grey);
}

.button-styles_btn__z2OS0.button-styles_color-neutral__LAtT8:disabled {
    border-color: var(--light-grey);
}

.button-styles_align-left__g4Tk\\+ {
    justify-content: flex-start;
}

.button-styles_align-space-between__elyAL {
    justify-content: space-between;
}

.button-styles_btn__z2OS0.button-styles_color-neutral__LAtT8 {
    background-color: #7b848e;
    border-color: #7b848e;
    color: #fff;
}

.button-styles_btn__z2OS0.button-styles_size-sm__orOnR {
    min-height: 32px;
    height: 32px;
    border-radius: 5px;
    padding: 0 14px;
}

.button-styles_btn__z2OS0.button-styles_size-sm__orOnR.button-styles_hasMinWidth__tXxri {
    min-width: 110px;
}

.button-styles_btn__z2OS0.button-styles_size-xs__a1nKM {
    min-height: 26px;
    height: 26px;
    border-radius: 5px;
    min-width: 80px;
    padding: 0 12px;
}

.button-styles_btn__z2OS0.button-styles_size-md__tQ3am {
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .button-styles_btn__z2OS0.button-styles_size-base__qtjEG {
        height: 44px;
        line-height: 44px;
        min-height: 44px;
        font-size: 16px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .button-styles_btn__z2OS0 {
        padding: 0 20px;
    }

    .button-styles_btn__z2OS0.button-styles_outline__l2CFi:not(.button-styles_size-xs__a1nKM) {
        height: 32px;
        line-height: 30px;
        min-height: 32px;
        font-size: 14px;
    }

    .button-styles_btn__z2OS0.button-styles_withIcon__NpFyl.button-styles_responsiveIcon__37Cr7 {
        width: 25px;
        height: 25px;
        background: transparent;
        padding: 0;
        border: 0;
        min-width: 25px;
        min-height: 25px;
        color: var(--primary-color);
        grid-gap: 0;
    }

    .button-styles_btn__z2OS0.button-styles_withIcon__NpFyl.button-styles_responsiveIcon__37Cr7:hover {
        --icon-color-custom: #fff;
        --icon-fill-color-custom: var(--primary-color);

        --icon-color-outer-custom: var(--primary-color);
    }

    .button-styles_btn__z2OS0.button-styles_withIcon__NpFyl.button-styles_responsiveIcon__37Cr7 span {
        width: 25px;
        height: 25px;
    }

    .button-styles_btn__z2OS0.button-styles_withIcon__NpFyl.button-styles_responsiveIcon__37Cr7 span svg {
        width: 25px;
        height: 25px;

        --icon-stroke: 1px;
    }

    .button-styles_btn__z2OS0.button-styles_withIcon__NpFyl.button-styles_responsiveIcon__37Cr7 .button-styles_label__KPWg1 {
        display: none;
    }

    .button-styles_btn__z2OS0 svg {
        width: 20px;
        height: 20px;
    }

    .button-styles_btn__z2OS0.button-styles_size-sm__orOnR svg,
    .button-styles_btn__z2OS0.button-styles_size-xs__a1nKM svg {
        width: 14px;
        height: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/button-styles.module.css"],"names":[],"mappings":"AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,WAAW;IACX,wCAAwC;IACxC,gCAAgC;IAChC,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB;;;kBAGc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;;IAEvB,6CAA6C;AACjD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yCAAyC;IACzC,uCAAuC;IACvC,WAAW;;IAEX,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,yCAAyC;IACzC,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA,sCAAsC;AACtC,sBAAsB;AACtB,uCAAuC;AACvC,2CAA2C;;AAE3C,oCAAoC;AACpC,IAAI;;AAEJ,gCAAgC;AAChC,uCAAuC;AACvC,gCAAgC;AAChC,8CAA8C;AAC9C,oBAAoB;AACpB,IAAI;;AAEJ,0BAA0B;AAC1B,2BAA2B;AAC3B,6BAA6B;AAC7B,sBAAsB;AACtB,oCAAoC;AACpC,kBAAkB;AAClB,IAAI;;AAEJ;IACI,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;;IAEhB,uBAAuB;IACvB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;AACA;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,UAAU;QACV,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,8CAA8C;;QAE9C,+CAA+C;IACnD;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;;QAEZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["@value screen-md-max, screen-lg-min from '../../breakpoints.css';\n\n.btn {\n    align-items: center;\n    grid-gap: 10px;\n    /*padding: 0 14px;*/\n    padding: 0 24px;\n    /*width: 100%;*/\n    color: #fff;\n    border: 0.5px solid var(--primary-color);\n    background: var(--primary-color);\n    font-size: 14px;\n    height: 40px;\n    min-height: 40px;\n    /*line-height: 40px;*/\n    transition:\n        background-color 0.4s,\n        border-color 0.4s,\n        color 0.4s;\n    display: inline-flex;\n    text-align: center;\n    justify-content: center;\n\n    /*--icon-color-custom: var(--primary-color);*/\n}\n\n.btn:not(.hasMinWidth) {\n    min-width: 75px;\n}\n\n.btn.hasMinWidth {\n    min-width: 140px;\n}\n\n.btn.grey {\n    --primary-color: #7b848e;\n}\n\n.btn svg {\n    width: 20px;\n    height: 20px;\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.btn:not(.secondary) {\n    border-radius: 10px;\n}\n\n.withIcon {\n    padding: 0 14px;\n    /*min-width: 120px;*/\n}\n\n.btn:not(:disabled):hover {\n    border-color: var(--primary-color-active);\n    background: var(--primary-color-active);\n    color: #fff;\n\n    --icon-color-custom: #fff;\n}\n\n.outline {\n    background: transparent;\n    color: var(--primary-color);\n    --icon-color-custom: var(--primary-color);\n    /*border-radius: 2px;*/\n    /*font-weight: 300;*/\n}\n\n.outline:not(:disabled):hover {\n    background: #1650b4;\n    border-color: #1650b4;\n    color: #fff;\n}\n\n/*.btn:disabled:not(.disabledLight) {*/\n/*    color: #7b848e;*/\n/*    border-color: var(--light-grey);*/\n/*    background-color: var(--light-grey);*/\n\n/*    --icon-color-custom: #7b848e;*/\n/*}*/\n\n/*.btn:disabled.disabledLight {*/\n/*    border-color: var(--light-grey);*/\n/*    color: var(--light-grey);*/\n/*    --icon-color-custom: var(--light-grey);*/\n/*    opacity: 0.8;*/\n/*}*/\n\n/*.btn:disabled.outline {*/\n/*    background: #f0f3f7;*/\n/*    border-color: #1650b4;*/\n/*    color: #1650b4;*/\n/*    --icon-color-custom: #1650b4;*/\n/*    opacity: 1;*/\n/*}*/\n\n.btn span {\n    margin-top: auto;\n    margin-bottom: auto;\n    display: inline-flex;\n}\n\n.fullWidth {\n    width: 100%;\n}\n\n.minWidth {\n    min-width: 300px;\n    justify-content: flex-start;\n}\n\n.close {\n    background: transparent;\n    border: 0;\n    position: absolute;\n    z-index: 4;\n    top: 14px;\n    right: 14px;\n    padding: 2px;\n}\n\n.secondary {\n    background-color: #f0f3f7;\n    color: #1650b4;\n    border-color: #1650b4;\n    border-radius: 5px;\n    min-width: 110px;\n\n    /*background: #fbfbfb;*/\n    /*border-color: #0c3b8d;*/\n    /*color: var(--primary-color);*/\n}\n\n.secondary.outline {\n    background-color: #ffffff;\n}\n\n.btn:disabled {\n    cursor: default;\n    border-color: var(--light-grey);\n}\n\n.btn:not(.secondary):disabled {\n    background-color: var(--light-grey);\n    color: #fff;\n}\n\n.btn.secondary:disabled {\n    color: var(--light-grey);\n    --icon-color-custom: var(--light-grey);\n}\n\n.btn.color-neutral:disabled {\n    border-color: var(--light-grey);\n}\n\n.align-left {\n    justify-content: flex-start;\n}\n\n.align-space-between {\n    justify-content: space-between;\n}\n\n.btn.color-neutral {\n    background-color: #7b848e;\n    border-color: #7b848e;\n    color: #fff;\n}\n\n.btn.size-sm {\n    min-height: 32px;\n    height: 32px;\n    border-radius: 5px;\n    padding: 0 14px;\n}\n\n.btn.size-sm.hasMinWidth {\n    min-width: 110px;\n}\n\n.btn.size-xs {\n    min-height: 26px;\n    height: 26px;\n    border-radius: 5px;\n    min-width: 80px;\n    padding: 0 12px;\n}\n\n.btn.size-md {\n}\n\n@media screen-lg-min {\n    .btn.size-base {\n        height: 44px;\n        line-height: 44px;\n        min-height: 44px;\n        font-size: 16px;\n    }\n}\n\n@media screen-md-max {\n    .btn {\n        padding: 0 20px;\n    }\n\n    .btn.outline:not(.size-xs) {\n        height: 32px;\n        line-height: 30px;\n        min-height: 32px;\n        font-size: 14px;\n    }\n\n    .btn.withIcon.responsiveIcon {\n        width: 25px;\n        height: 25px;\n        background: transparent;\n        padding: 0;\n        border: 0;\n        min-width: 25px;\n        min-height: 25px;\n        color: var(--primary-color);\n        grid-gap: 0;\n    }\n\n    .btn.withIcon.responsiveIcon:hover {\n        --icon-color-custom: #fff;\n        --icon-fill-color-custom: var(--primary-color);\n\n        --icon-color-outer-custom: var(--primary-color);\n    }\n\n    .btn.withIcon.responsiveIcon span {\n        width: 25px;\n        height: 25px;\n    }\n\n    .btn.withIcon.responsiveIcon span svg {\n        width: 25px;\n        height: 25px;\n\n        --icon-stroke: 1px;\n    }\n\n    .btn.withIcon.responsiveIcon .label {\n        display: none;\n    }\n\n    .btn svg {\n        width: 20px;\n        height: 20px;\n    }\n\n    .btn.size-sm svg,\n    .btn.size-xs svg {\n        width: 14px;\n        height: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"btn": `button-styles_btn__z2OS0`,
	"hasMinWidth": `button-styles_hasMinWidth__tXxri`,
	"grey": `button-styles_grey__w-EJ5`,
	"secondary": `button-styles_secondary__q+4SW`,
	"withIcon": `button-styles_withIcon__NpFyl`,
	"outline": `button-styles_outline__l2CFi`,
	"fullWidth": `button-styles_fullWidth__WtK-M`,
	"minWidth": `button-styles_minWidth__NDeXg`,
	"close": `button-styles_close__fjkOj`,
	"color-neutral": `button-styles_color-neutral__LAtT8`,
	"align-left": `button-styles_align-left__g4Tk+`,
	"align-space-between": `button-styles_align-space-between__elyAL`,
	"size-sm": `button-styles_size-sm__orOnR`,
	"size-xs": `button-styles_size-xs__a1nKM`,
	"size-md": `button-styles_size-md__tQ3am`,
	"size-base": `button-styles_size-base__qtjEG`,
	"responsiveIcon": `button-styles_responsiveIcon__37Cr7`,
	"label": `button-styles_label__KPWg1`
};
export default ___CSS_LOADER_EXPORT___;
